import { buildSubscriptionPayload, submitSubscription } from './lazy-oaf-klaviyo-subscription.js';

export function buildNewsletterSubscriptionPayload(email, listId) {
  return buildSubscriptionPayload({ email, listId, source: 'Footer Newsletter' });
}

export function submitNewsletterSignup(options) {
  return submitSubscription({ ...options, source: 'Footer Newsletter' });
}

const HTMLElementBase = globalThis.HTMLElement || class {};

class NewsletterSocial extends HTMLElementBase {
  connectedCallback() {
    this.abort?.abort();
    this.abort = new AbortController();
    const { signal } = this.abort;

    this.form = this.querySelector('[data-newsletter-form]');
    this.dialog = this.querySelector('dialog-component');
    this.form?.addEventListener('submit', this.onSubmit, { signal });
    this.querySelector('[data-newsletter-continue]')?.addEventListener('click', this.onContinue, { signal });
    this.dialog?.addEventListener('dialog:close', this.onDialogClose, { signal });
  }

  disconnectedCallback() {
    this.requestAbort?.abort();
    this.abort?.abort();
  }

  onSubmit = async (event) => {
    event.preventDefault();
    if (this.submitting || !this.form?.reportValidity()) return;

    const email = this.querySelector('[data-newsletter-email]')?.value.trim();
    if (!email) return;

    this.setStatus('');
    this.setSubmitting(true);
    this.requestAbort?.abort();
    const requestAbort = new AbortController();
    this.requestAbort = requestAbort;

    try {
      await submitNewsletterSignup({
        email,
        companyId: this.dataset.klaviyoCompanyId?.trim(),
        listId: this.dataset.klaviyoListId?.trim(),
        signal: requestAbort.signal,
      });
      if (requestAbort.signal.aborted) return;
      this.showSuccess();
    } catch {
      if (!requestAbort.signal.aborted) {
        this.setStatus('We couldn’t sign you up just now. Please try again.');
      }
    } finally {
      if (this.requestAbort === requestAbort) {
        this.requestAbort = undefined;
        this.setSubmitting(false);
      }
    }
  };

  onContinue = async () => {
    await this.dialog?.closeDialog?.();
    this.reset();
  };

  onDialogClose = () => {
    this.reset();
  };

  setSubmitting(submitting) {
    this.submitting = submitting;
    const button = this.querySelector('[data-newsletter-submit]');
    if (!button) return;

    button.disabled = submitting;
    button.toggleAttribute('aria-busy', submitting);
    button.textContent = submitting ? 'SENDING…' : button.dataset.defaultLabel;
  }

  setStatus(message) {
    const status = this.querySelector('[data-newsletter-status]');
    if (status) status.textContent = message;
  }

  showSuccess() {
    const formState = this.querySelector('[data-newsletter-form-state]');
    const successState = this.querySelector('[data-newsletter-success]');
    if (formState) formState.hidden = true;
    if (successState) successState.hidden = false;
    successState?.querySelector('[data-newsletter-success-heading]')?.focus({ preventScroll: true });
  }

  reset() {
    const formState = this.querySelector('[data-newsletter-form-state]');
    const successState = this.querySelector('[data-newsletter-success]');
    const wasSuccessful = successState && !successState.hidden;

    if (formState) formState.hidden = false;
    if (successState) successState.hidden = true;
    if (wasSuccessful) this.form?.reset();
    this.requestAbort?.abort();
    this.requestAbort = undefined;
    this.setStatus('');
    this.setSubmitting(false);
  }
}

if (globalThis.customElements && !customElements.get('newsletter-social')) {
  customElements.define('newsletter-social', NewsletterSocial);
}
